import ReportProblem from '@mui/icons-material/ReportProblem';
import { FormattedMessage } from 'react-intl';
import { PATHS } from '../../config/consts';
import { Alert } from '../index';
import Link from '../Link';
import messages from './messages';

interface IDormakabaAlert {
  companyId: string;
  hasDormakabaAccessForUser: boolean | undefined;
  isSite6PinLength: boolean;
  isSiteWithDormakabaIntegrationEnabled: boolean | undefined;
  pinLength: number | undefined;
  siteId: string;
}

function DormakabaAlert({
  companyId,
  hasDormakabaAccessForUser,
  isSite6PinLength,
  isSiteWithDormakabaIntegrationEnabled,
  pinLength,
  siteId,
}: IDormakabaAlert) {
  if (!isSiteWithDormakabaIntegrationEnabled || !hasDormakabaAccessForUser || pinLength === 6) {
    return null;
  }

  if (isSite6PinLength) {
    return (
      <Alert severity="warning" icon={<ReportProblem />}>
        <FormattedMessage {...messages.userAccessFormPinWarningDormakaba2} />
      </Alert>
    );
  }

  return (
    <Alert severity="warning" icon={<ReportProblem />}>
      <FormattedMessage
        values={{
          link: (chunks) => (
            <Link to={PATHS.SITE_SETTINGS_ACCESS.replace(':companyId', companyId).replace(':siteId', siteId)}>
              {chunks}
            </Link>
          ),
        }}
        {...messages.userAccessFormPinWarningDormakaba1}
      />
    </Alert>
  );
}

export default DormakabaAlert;
